module.exports = __webpack_public_path__ + "img/1-24.aef579b6.jpg";